import { Color } from './color';
/**
 * +
 */
export const Plus = (options, context) => {
    return Color(Object.assign({ colorAttribute: 'stroke', symbol: 'plus' }, options), context);
};
Plus.props = Object.assign({ defaultMarker: 'plus' }, Color.props);
//# sourceMappingURL=plus.js.map